module.exports = __webpack_public_path__ + "img/global-outlined-white.29f490aa.svg";